import { useCallback, useEffect, useState } from "react";
import { FaAnglesLeft, FaAnglesRight } from "react-icons/fa6";
import { AppSidebar } from "../AppSidebar/AppSidebar";
import { EnvBadge } from "../EnvBadge/EnvBadge";
import "./AppShell.css";

const STORAGE_KEY = "spm.appShell.sideCollapsed";

/**
 * Layout autenticado: frame central (menu + painel) com recolher/expandir.
 * Largura do frame estável; ao recolher o menu, o painel principal absorve o espaço.
 * NavProvider fica acima (App.jsx) para o catálogo de menus não remontar a cada rota.
 */
export function AppShell({ children }) {
  const [sideCollapsed, setSideCollapsed] = useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, sideCollapsed ? "1" : "0");
    } catch {
      /* ignore */
    }
  }, [sideCollapsed]);

  const toggleSide = useCallback(() => {
    setSideCollapsed((v) => !v);
  }, []);

  return (
    <div
      className={
        sideCollapsed ? "app-shell app-shell--side-collapsed" : "app-shell"
      }
    >
      <div className="app-shell__frame">
        <aside className="app-shell__side" aria-label="Navegação">
          <div className="app-shell__side-header">
            <button
              type="button"
              className="app-shell__icon-btn"
              onClick={toggleSide}
              title={sideCollapsed ? "Expandir menu" : "Recolher menu"}
              aria-label={sideCollapsed ? "Expandir menu" : "Recolher menu"}
              aria-expanded={!sideCollapsed}
            >
              {sideCollapsed ? (
                <FaAnglesRight aria-hidden />
              ) : (
                <FaAnglesLeft aria-hidden />
              )}
            </button>
            <EnvBadge />
          </div>
          <div className="app-shell__side-body">
            <AppSidebar collapsed={sideCollapsed} />
          </div>
        </aside>
        <div className="app-shell__main">{children}</div>
      </div>
    </div>
  );
}

export default AppShell;
